import { useEffect } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { Creators } from "./model"
import withUrlParams from "hocs/withUrlParams"

function AlphaTheoryShare({ dispatch, params }) {
  const { alphaTheoryShareId } = params

  useEffect(() => {
    dispatch(Creators.fetchSnapshot(alphaTheoryShareId))
  }, [dispatch, alphaTheoryShareId])
  return null
}

AlphaTheoryShare.propTypes = {
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
}

// connect is required for the component to get dispatch.
// This is unique to this component, and shouldn't be replicated elsewhere.
export default withUrlParams(connect()(AlphaTheoryShare))
